"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const antd_1 = require("antd");
const react_1 = __importStar(require("react"));
const react_router_1 = require("react-router");
const response_codes_1 = require("../../../../../assets/constants/response_codes");
const strings_1 = require("../../../../../assets/strings/strings");
const underline_1 = __importDefault(require("../../../../../components/underline"));
const auth_requests_1 = require("../../../../../dataSource/auth_requests");
const user_requests_1 = require("../../../../../dataSource/user_requests");
const RoutesPaths_1 = require("../../../../../routes/RoutesPaths");
const message_utils_1 = __importDefault(require("../../../../../utils/message_utils"));
const users_1 = require("../../../../../utils/users");
require("./ConfirmDeleteUser.scss");
const ConfirmDeleteUser = ({ close }) => {
    const history = (0, react_router_1.useHistory)();
    const handleConfirm = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield (0, user_requests_1.deleteMyProfile)();
        if (response.code === response_codes_1.DeleteProfileCodes.success) {
            message_utils_1.default.success({ message: strings_1.DeleteProfileMessages.deleteProfileSuccessfully });
            (0, auth_requests_1.userLogout)();
            (0, users_1.removeUserFromStorage)();
            close();
            history.push(RoutesPaths_1.routesPaths.root);
        }
        else {
            switch (response.code) {
                default:
                    message_utils_1.default.error();
                    break;
            }
        }
    }), [close, history]);
    return (react_1.default.createElement("div", { className: "ConfirmDeleteUser" },
        react_1.default.createElement("span", { className: "title" },
            "Excluir",
            react_1.default.createElement("span", null, ` usuário`)),
        react_1.default.createElement(underline_1.default, { style: { marginLeft: '32px', marginBottom: '30px' } }),
        react_1.default.createElement("span", { className: "sub-title" }, "Deseja mesmo excluir a sua conta?"),
        react_1.default.createElement("div", { className: "actions" },
            react_1.default.createElement(antd_1.Button, { onClick: close, style: { borderRadius: '5px' } }, "N\u00E3o, retornar ao meu perfil."),
            react_1.default.createElement(antd_1.Button, { onClick: handleConfirm, type: "primary", style: { borderRadius: '5px' } }, "Sim, quero cancelar a minha conta."))));
};
exports.default = ConfirmDeleteUser;
